import DOMPurify from 'dompurify';
import React, {useState} from 'react';
import toast from 'react-hot-toast';

export function Case2({num_societaire, onNext, onPrevious, formData, setFormData}) {
    const [numeroSocietaire, setNumeroSocietaire] = useState(num_societaire);

    const validateSocietaire = (numero) => {
        return numero !== null && numero !== '';
    };

    const handleInputChange = (e) => {
        e.preventDefault();
        setFormData({...formData, numeroSocietaire: null})
        const value = DOMPurify.sanitize(e.target.value);
        setNumeroSocietaire(value);

        if (!validateSocietaire(value)) {
            toast.error('Le numéro de sociétaire ne doit pas être vide.');
        } 
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validateSocietaire(numeroSocietaire)) {
            return;
        }
        onNext({numeroSocietaire});
    };

    return (
        <div className="texte">
            <h5 className="centered"><b>Etape 1/5</b></h5>
            <hr/>
            <div className="centered">
                <h5><b>Votre numéro de sociétaire *</b></h5>
            </div>
            <span>Si le numéro n'est pas correct, vous pouvez le corriger avant de cliquer sur suivant.</span>
            <p><i>* champs obligatoire</i></p>
            <div>
                <input type="text" className="form-control"
                       value={formData.numeroSocietaire ? formData.numeroSocietaire : numeroSocietaire}
                       onChange={handleInputChange}/>
            </div>

            <div className="app-buttons">
                <button className="buttons-secondaire" onClick={onPrevious}>Retour</button>
                <button className="buttons-primaire" onClick={handleSubmit}>Suivant</button>
            </div>
        </div>
    );
}
